import ListItem from 'LuxKit/List/ListItem'
import React from 'react'
import { useIntl } from 'react-intl'

interface Props {
  inputValue: string
}

function NoAirportsOptionListItem(props: Props) {
  const { inputValue } = props
  const intl = useIntl()

  const title = intl.formatMessage(
    {
      id: 'OQtbyLMwE1',
      defaultMessage: 'Sorry, we couldn’t find "{inputValue}"',
      description: 'Error message when no airports are found for the search input',
    },
    { inputValue },
  )

  const subtitle = intl.formatMessage({
    id: 'iP6LRK1UEo',
    defaultMessage: 'Check your spelling, or try searching for a new airport.',
    description: 'Helpful suggestion when no airports are found',
  })

  return <ListItem
    title={title}
    subtitle={subtitle}
  />
}

export default NoAirportsOptionListItem
